import React from 'react';
import styles from './deleteMEnuItem.module.scss';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import { Trash } from '../../../../../../Assets/Icons';
import { Trans } from 'react-i18next';
import Button from '../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';

interface IProps {
    id: number,
    title: string,
    onDelete: (id: number) => void,
    onClose: () => void,
    loading:boolean
};

const DeleteMenuItem:React.FC<IProps> = (props) => {
    const { id, title, onDelete, onClose,loading } = props;
    const { t } = useLanguagesHooks();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={Trash} alt='trash.svg'/>
                <p>
                    {t('My_Business.Delete_Item.Header')}
                </p>
            </div>
            <div className={styles.content}>
            <div className={styles.text}>
                <Trans
                    i18nKey="My_Business.Delete_Item.Remove_Text"
                    values={{ title }}
                    components={{
                        strong: <span className={styles.categoryTitle} />,
                    }}
                />
                </div>
                <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Cancel')}
                        type='button'
                        onClick={onClose}
                        buttonStyle={styles.closeButton}
                    />
                    <Button
                        buttonType={ButtonTypes.Primery}
                        title={t('Buttons.Delete')}
                        type='button'
                        onClick={() => onDelete(id)}
                        isLoading={loading}
                        buttonStyle={styles.button}
                    />
                </div>
            </div>
        </div>
    )
}

export default DeleteMenuItem
